import {useFetchHousing, useFetchHousingLocation} from 'hooks';
import {AUTH_INIT_MODELS} from '@chekin/core';
import {useChekinSDK} from 'context/ChekinSDK';

function useHousing() {
  const {objectId: housingId, modelName} = useChekinSDK();

  const {
    data: housing,
    isSuccess: isSuccessLoadedHousing,
    isLoading: isHousingLoading,
  } = useFetchHousing(housingId, {
    refetchOnWindowFocus: false,
    enabled: modelName === AUTH_INIT_MODELS.housing,
  });

  const {
    data: locationCountry,
    isSuccess: isSuccessLoadedHousingLocation,
    isLoading: isLocationLoading,
  } = useFetchHousingLocation({
    housingLocation: housing?.location,
  });

  return {
    housing,
    housingLocation: locationCountry,
    housingCountry: locationCountry?.country?.code,
    isLoaded: isSuccessLoadedHousing && isSuccessLoadedHousingLocation,
    isLoading: isHousingLoading || isLocationLoading,
  };
}

export {useHousing};
